import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Home, Compass } from 'lucide-react';
import { useThemeContext } from '@utils/hooks/use-theme-context';
import { PATHS } from '../router/paths';

export default function NotFound() {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();

  return (
    <main
      className="bg-app min-h-screen grid place-items-center px-6 py-24 sm:py-32 lg:px-8"
      style={{ color: getColour('normalText') }}
    >
      <div className="text-center">
        <div
          className="mx-auto mb-6 h-20 w-20 rounded-full border-2 border-dashed border-hairline flex items-center justify-center"
          style={{ color: getColour('inactiveText') }}
        >
          <Compass className="h-8 w-8" />
        </div>
        <p
          className="text-base font-semibold"
          style={{ color: getColour('activeText') }}
        >
          404
        </p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">
          {t('page-not-found') || 'Page not found'}
        </h1>
        <p
          className="mt-6 text-base leading-7"
          style={{ color: getColour('inactiveText') }}
        >
          {t('sorry-we-couldnt-find-the-page-youre-looking-for') ||
            "Sorry, we couldn't find the page you're looking for."}
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link
            to={PATHS().HOME}
            className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-semibold shadow-card hover:opacity-90 transition-opacity focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            <Home size={16} />
            {t('go-back-to-home') || 'Go back home'}
          </Link>
        </div>
      </div>
    </main>
  );
}
